import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const LOGO_URL = "/logo_concept_1.png";

export default function Footer() {
  return (
    <footer className="footer-gradient pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo & About */}
          <div className="md:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Cotton Candy Girl" 
              className="h-20 w-auto rounded-xl mb-4"
            />
            <p className="text-[#888888] text-sm leading-relaxed">
              Wholesale cotton candy for retailers, resorts, entertainment venues, and specialty shops.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-[#4A4A4A] mb-4 text-lg">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#888888] hover:text-[#FF9EAA] transition-colors text-sm" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/wholesale" className="text-[#888888] hover:text-[#FF9EAA] transition-colors text-sm" data-testid="footer-link-wholesale">
                  Wholesale
                </Link>
              </li>
              <li>
                <Link to="/flavors" className="text-[#888888] hover:text-[#FF9EAA] transition-colors text-sm" data-testid="footer-link-flavors">
                  Flavors
                </Link>
              </li>
              <li>
                <Link to="/uv-cotton-candy" className="text-[#888888] hover:text-[#FF9EAA] transition-colors text-sm" data-testid="footer-link-uv">
                  UV Cotton Candy
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-[#888888] hover:text-[#FF9EAA] transition-colors text-sm" data-testid="footer-link-events">
                  Live Events
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#888888] hover:text-[#FF9EAA] transition-colors text-sm" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-semibold text-[#4A4A4A] mb-4 text-lg">Service Areas</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-[#888888] text-sm">
                <MapPin size={16} className="text-[#FF9EAA]" />
                <span>Las Vegas, Nevada</span>
              </li>
              <li className="flex items-center gap-2 text-[#888888] text-sm">
                <MapPin size={16} className="text-[#FF9EAA]" />
                <span>Boise, Idaho</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-[#4A4A4A] mb-4 text-lg">
              <Link to="/contact" className="hover:text-[#FF9EAA] transition-colors" data-testid="footer-contact-link">Contact Us</Link>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-[#888888] text-sm">
                <Mail size={16} className="text-[#FF9EAA]" />
                <a href="mailto:shea@cottoncandygirl.co" className="hover:text-[#FF9EAA] transition-colors" data-testid="footer-email">
                  shea@cottoncandygirl.co
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-pink-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#888888] text-sm">
              &copy; {new Date().getFullYear()} Cotton Candy Girl. All rights reserved.
            </p>
            <p className="text-[#888888] text-sm">
              cottoncandygirl.co
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
